import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon'
import { MenuProps } from 'antd'
import React from 'react'
import {
  ButtonIcon,
  DownLogo,
  StyledDropdown,
} from './CyIconDropdownButtonStyle'

type Props = {
  icon?:
    | React.ComponentType<
        CustomIconComponentProps | React.SVGProps<SVGSVGElement>
      >
    | React.ForwardRefExoticComponent<CustomIconComponentProps>
  iconElement?: JSX.Element
  items: MenuProps['items']
}

function CyIconDropdownButton({ icon, items, iconElement }: Props) {
  const menuProps: MenuProps = {
    items,
  }
  return (
    <StyledDropdown
      arrow={{ pointAtCenter: true }}
      menu={menuProps}
      placement='bottomRight'
      trigger={['click']}
      align={{ offset: [0, -10] }}
    >
      <div>
        {icon && <ButtonIcon component={icon} />}
        {iconElement && iconElement}
        <DownLogo />
      </div>
    </StyledDropdown>
  )
}

export default CyIconDropdownButton
